import api from '@/utils/api'

export default {
    getAssignmentStatusCount(filter) {
        const params = new URLSearchParams()
        if (filter.contractorId) {
            params.append('contractorId', filter.contractorId)
        }
        if (filter.type) {
            params.append('type', filter.type)
        }
        if (filter.assignedToContractorAtGte && filter.assignedToContractorAtGte) {
            params.append('assignedToContractorAtGte', filter.assignedToContractorAtGte)
            params.append('assignedToContractorAtLte', filter.assignedToContractorAtLte)
        }
        if (filter.createdAtGte && filter.createdAtLte) {
            params.append('createdAtLte', filter.createdAtLte)
            params.append('createdAtGte', filter.createdAtGte)
        }
        return api.get('assignments/counts' + `?${params.toString()}`)
    }
}
